<template>
  <footer id="contacto">
    <div class="footer-grid">
      <div class="footer-brand">
        <span class="logo-text">VISION HOUSE</span>
        <p>Equipando generaciones, transformando naciones. Un ministerio cristiano dedicado a la formación integral de
          líderes en Guatemala.</p>
        <div class="social-links">
          <a v-for="social in socials" :key="social.icon" :href="social.link" :aria-label="social.label">
            <i :class="social.icon"></i>
          </a>
        </div>
      </div>
      <div class="footer-column">
        <h4>Navegación</h4>
        <ul>
          <li v-for="item in navItems" :key="item.id">
            <a :href="'#' + item.id" @click.prevent="scrollTo(item.id)">
              <i class="fas fa-chevron-right"></i> {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>Involúcrate</h4>
        <ul>
          <li v-for="item in engageItems" :key="item.id">
            <a :href="'#' + item.id" @click.prevent="scrollTo(item.id)">
              <i class="fas fa-chevron-right"></i> {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
      <div class="footer-column">
        <h4>Contacto</h4>
        <div v-for="(contact, i) in contacts" :key="i" class="footer-contact">
          <i :class="contact.icon"></i>
          <span>{{ contact.text }}</span>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p> Vision House - Todos los derechos reservados | Hecho con <i class="fas fa-heart"
          style="color:var(--vh-rosa)"></i> para Guatemala</p>
    </div>
  </footer>
</template>

<script setup lang="ts">
const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const socials = [
  { icon: 'fab fa-whatsapp', label: 'WhatsApp', link: 'https://wa.me/50241498852?text=Hola%20visite%20tu%20pagina%20de%20Vision%20House' },
  { icon: 'fab fa-facebook-f', label: 'Facebook', link: 'https://www.facebook.com/profile.php?id=61574895160076' },
  { icon: 'fab fa-instagram', label: 'Instagram', link: 'https://www.instagram.com/vision_house_gt/' },
  { icon: 'fab fa-youtube', label: 'YouTube', link: '#' },
  { icon: 'fab fa-tiktok', label: 'TikTok', link: '#' }
]

const navItems = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'nosotros', label: 'Nosotros' },
  { id: 'pilares', label: 'Misión y Visión' },
  { id: 'programas', label: 'Programas' }
]

const engageItems = [
  { id: 'donar', label: 'Donaciones' },
  { id: 'voluntariado', label: 'Voluntariado' },
  { id: 'programas', label: 'Alianzas' },
  { id: 'programas', label: 'Eventos' }
]

const contacts = [
  { icon: 'fas fa-envelope', text: 'visionhousegt@gmail.com' },
  { icon: 'fas fa-phone', text: '+502 4149-8852' },
  { icon: 'fas fa-map-marker-alt', text: 'Amatitlán, Guatemala' }
]
</script>

<style scoped>
footer {
  background: var(--vh-azul-oscuro);
  color: white;
  padding: 5rem 5% 2rem;
  position: relative;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 4rem;
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 4rem;
}

.footer-brand .logo-text {
  color: white;
  font-size: 2rem;
  margin-bottom: 1.2rem;
  display: block;
  font-family: 'League Spartan', sans-serif;
  font-weight: 800;
}

.footer-brand p {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.9;
  margin-bottom: 2rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links a {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: var(--vh-transicion);
  text-decoration: none;
  font-size: 1.1rem;
}

.social-links a:hover {
  background: var(--vh-dorado);
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 5px 15px rgba(251, 166, 54, 0.3);
}

.footer-column h4 {
  font-size: 1.2rem;
  margin-bottom: 1.8rem;
  color: var(--vh-dorado);
  font-family: 'League Spartan', sans-serif;
}

.footer-column ul {
  list-style: none;
}

.footer-column ul li {
  margin-bottom: 1rem;
}

.footer-column ul li a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: var(--vh-transicion);
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 0.95rem;
}

.footer-column ul li a:hover {
  color: var(--vh-dorado);
  padding-left: 8px;
}

.footer-contact {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.2rem;
  color: rgba(255, 255, 255, 0.7);
}

.footer-contact i {
  color: var(--vh-dorado);
  margin-top: 4px;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
  max-width: 1200px;
  margin: 0 auto;
}

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }
}

@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
}
</style>
